import { IS_FETCHING_BILLING_DETAILS } from 'constants/actions';

import { SUBSCRIPTION_STATUS_TRIALING } from '../../../shared/constants/billingAndPayments';

const DEFAULT_STATE = {
  name: null,
  address: null,
  credits: null, // in cents
  updating: false,
  first_fetch_done: false,
  primary_user_id: null,
  current_plan: null,
  billing_email: null,
  payment_method: [],
  available_plans: null,
  billingEntityId: null,
  invitations: [],
  invoices: [],
  showUpgradeModal: false,
  isFetchingBillingDetails: false,
};

const billingReducer = (state = DEFAULT_STATE, action) => {
  let newState = null;

  switch (action.type) {
    case IS_FETCHING_BILLING_DETAILS: {
      newState = {
        ...state,
        isFetchingBillingDetails: action.isFetching,
      };

      break;
    }

    default:
      return state;
  }

  newState.isFreeUser = !newState.current_plan;
  newState.isTrialing =
    newState.current_plan &&
    newState.current_plan.status === SUBSCRIPTION_STATUS_TRIALING;
  newState.isCancelling =
    !newState.isTrialing &&
    newState.current_plan &&
    newState.current_plan.cancel_at_period_end;

  return newState;
};

export default billingReducer;
